import React from "react";
import { Link, useLocation } from "react-router-dom";
import checkAccess from "utils/checkAccess";
import { cn } from "utils/cn";
function NavbarLinksBase() {
  const location = useLocation();

  return (
    <div className="flex items-center text-sm lg:pb-1">
       {/* {checkAccess("read_report_chat_user") && (
        <div
          className={cn(
            "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap  outline-transparent",
            "rounded-none border-b-2 border-transparent bg-none!",
            "focus:text-mono focus:bg-none ",
            "data-[state=open]:bg-transparent data-[state=open]:text-mono ",
            "data-[active=true]:font-medium data-[active=true]:border-mono ",
            location.pathname === "/report/chat" && "font-medium",
          )}
        >
          <Link to={"/report/chat"}>Report Chat</Link>
        </div>
      )}
      {checkAccess("read_report_problem") && (
        <div
          className={cn(
            "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap  outline-transparent",
            "rounded-none border-b-2 border-transparent bg-none!",
            "focus:text-mono focus:bg-none ",
            "data-[state=open]:bg-transparent data-[state=open]:text-mono ",
            "data-[active=true]:font-medium data-[active=true]:border-mono ",
            location.pathname === "/report/problem" && "font-medium",
          )}
        >
          <Link to={"/report/problem"}>Report Problem</Link>
        </div>
      )} */}
      {checkAccess("read_common_issue") && (
        <div
          className={cn(
            "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap  outline-transparent",
            "rounded-none border-b-2 border-transparent bg-none!",
            "focus:text-mono focus:bg-none",
            "data-[state=open]:bg-transparent data-[state=open]:text-mono ",
            "data-[active=true]:font-medium data-[active=true]:border-mono ",
            location.pathname === "/common/issue" && "font-medium",
          )}
        >
          <Link to={"/common/issue"}>Common Issues</Link>
        </div>
      )}
      {checkAccess("read_feedback") && (
        <div
          className={cn(
            "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap  outline-transparent",
            "rounded-none border-b-2 border-transparent bg-none!",
            "focus:text-mono focus:bg-none ",
            "data-[state=open]:bg-transparent data-[state=open]:text-mono ",
            "data-[active=true]:font-medium data-[active=true]:border-mono ",
            location.pathname === "/feedback" && "font-medium",
          )}
        >
          <Link to={"/feedback"}>Feedback</Link>
        </div>
      )}
    </div>
  );
}

export const NavbarLinks = React.memo(NavbarLinksBase);
